import { combineEpics } from 'redux-observable';
import { getTeamMembersEpic } from './get-team-members';
import { updateTeamMemberEpic } from './update-team-member';
import { createTeamMemberEpic } from './create-team-member';
import { removeTeamMemberEpic } from './remove-team-member';
import { getTeamAfterLabelActiveEpic } from './get-team-after-label-active';

const teamsEpic = combineEpics(
  getTeamMembersEpic,
  updateTeamMemberEpic,
  createTeamMemberEpic,
  removeTeamMemberEpic,
  getTeamAfterLabelActiveEpic
);

export default teamsEpic;
